import { Button, Col, Container, Form, Nav, Row, Tab } from "react-bootstrap";
import Footer from "../../Commons/Footer/Footer";
import Navigation from "../../Commons/Navigation/Navigation";
import { useEffect, useState } from "react";
import { FeedbackButton, IMG, isValidUrl } from "../../Commons/Functions";
import { useGameContext } from "../../Commons/GameContext";
import { v4 as uuidv4 } from 'uuid';
import '../../Commons/Commons.scss'
import Preferences_Sleeves from "./Preferences_Sleeves";
import Preferences_Playmat from "./Preferences_Playmat";
import Preferences_Options from "./Preferences_Options";
import Preferences_Profile from "./Preferences_Profile";

export function defaultPlayerData() {
    return {
        name: "Player-" + (Math.floor(Math.random() * 9000) + 1000),
        avatar: "",
        background: ""
    }
}

export function defaultOptionsData() {
    return {
        costAutoPay: true,
        visiblePlayArea: true,
        focusedCardSize: "Default",
        autoPlayToPile: false,
        focusActivePlayer: true,
        playerId: "TCGA-AN-" + uuidv4(),
    }
}

export default function Preferences() {
    const [profile, setProfile] = useState(false)
    const [options, setOptions] = useState(false)

    useEffect(() => {
        let profileJSON = localStorage.getItem('user_preference');

        if (profileJSON) {
            const profileData = JSON.parse(profileJSON);
            setProfile(profileData)
        } else {
            let defaultData = defaultPlayerData()
            localStorage.setItem('user_preference', JSON.stringify(defaultData));
            setProfile(defaultData)
        }

        setOptions(getSavedOptions())
    }, [])

    return (
        <div className="w-100">
            <Navigation currentPage="Preferences" />
            <div className="below-navbar">
                <Container className="p-5" style={{ minHeight: "85vh" }}>
                    {profile && (<PreferenceSection
                        profileData={profile}
                        setProfileData={setProfile}
                        options={options}
                        setOptions={setOptions}
                    />)}
                </Container>
            </div>
            <Footer></Footer>
        </div>
    )
}

export function getSavedOptions() {
    const deepMergeDefaults = (defaults, stored) => {
        const result = { ...defaults };

        for (const key in stored) {
            if (stored[key] !== null && typeof stored[key] === "object" && !Array.isArray(stored[key])) {
                result[key] = deepMergeDefaults(defaults[key] || {}, stored[key]);
            } else {
                result[key] = stored[key];
            }
        }

        return result;
    }

    let optionsJSON = localStorage.getItem('user_options')

    const defaultData = defaultOptionsData();

    if (optionsJSON) {
        const optionsData = JSON.parse(optionsJSON);
        const mergedOptions = deepMergeDefaults(defaultData, optionsData);

        localStorage.setItem('user_options', JSON.stringify(mergedOptions));
        return mergedOptions;
    } else {
        localStorage.setItem('user_options', JSON.stringify(defaultData));
        return defaultData;
    }
}

export function PreferenceSection(props) {
    const { gameData } = useGameContext()

    function updateProfileField(field, value) {
        let tmp = { ...props.profileData }
        tmp[field] = value
        props.setProfileData(tmp)
        localStorage.setItem('user_preference', JSON.stringify(tmp));
    }

    return (<div className="d-flex flex-column preferences" style={{ minHeight: "70vh" }}>
        <Tab.Container id="left-tabs-example" defaultActiveKey="Options">
            <Row>
                <Col sm={2}>
                    <Nav variant="pills" className="flex-column">
                        <Nav.Item>
                            <Nav.Link eventKey="Options">Options</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="Profile">Profile</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="Playmat">Playmat</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="Sleeves" disabled>Sleeves</Nav.Link>
                        </Nav.Item>
                    </Nav>
                </Col>
                <Col sm={10}>
                    <Tab.Content>
                        <Tab.Pane eventKey="Options">
                            <Preferences_Options
                                gameData={gameData}
                                profileData={props.profileData}
                                options={props.options}
                                setOptions={props.setOptions}
                                updateProfileField={updateProfileField}
                            />
                        </Tab.Pane>
                        <Tab.Pane eventKey="Profile">
                            <Preferences_Profile profileData={props.profileData} options={props.options} updateProfileField={updateProfileField} />
                        </Tab.Pane>
                        <Tab.Pane eventKey="Playmat">
                            {gameData && (
                                <Preferences_Playmat gameData={gameData} profileData={props.profileData} updateProfileField={updateProfileField} />
                            )}
                        </Tab.Pane>
                        <Tab.Pane eventKey="Sleeves" mountOnEnter unmountOnExit>
                        {false && gameData && (<Preferences_Sleeves gameData={gameData} />)}
                        </Tab.Pane>
                    </Tab.Content>
                </Col>
            </Row>
        </Tab.Container>
    </div>)
}